<template>
  <span class="text-left">
    <ed-button class="btn btn-actionbar"
        @click="validateInvoices()"
        :disabled='disabled'
      >Edit Invoice
    </ed-button>

    <ed-modal
      :show='showModal'
      @close='showModal = false'
      title=''
      xsubtitle=''
      primaryButton='OK'
      secondaryButton='false'
    >
      <span slot="body">
        <p class="col-md-8 lh15">
          <span v-html="modalContent"></span>
        </p>
        <div class="clear"></div>
      </span>
    </ed-modal>
  </span>
</template>

<script>
export default {
  props: {
    rows: Array,
    fromPage: String
  },

  data() {
    return {
      showModal: false,
      modalContent: ''
    }
  },

  methods: {
    validateInvoices() {
      if (!this.rows || this.rows.length > 1) {
        this.modalContent = 'You can only edit one invoice at a time. Please deselect all invoices except for one and try again.'
        this.showModal = true
      } else {
        this.api.forms.post(
          this.api.$.invoice.list.validateEditInvoice,
          {
            isAll: false,
            paymentInvoiceIDs: JSON.stringify([this.rows[0].data.PaymentInvoiceID])
          }
        ).then(result => {
          if (result && result.data) {
            var errors = JSON.parse(result.data.Data)
            if (result.data.SuccessMessage !== 'Success') {
              this.modalContent = errors.BaseValidationResult.Data
              this.showModal = true
            } else {
              this.redirectToEditInvoice()
            }
          }
        })
      }
    },

    redirectToEditInvoice() {
      if (this.rows && this.rows.length === 1) {
        this.$router.push('/d/Invoices/edit?id=' + this.rows[0].data.PaymentInvoiceID + '&fromPage=' + this.fromPage)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Invoices/actions/edit-invoice.vue